import {
  ApacCandidateHeader,
  ApacCandidateHeaderFooterLinkProvider,
} from '@seek/apac-candidate-header-footer';

import { useHeaderFooterLinkProvider } from 'src/components/HeaderFooterLinks/HeaderFooterLinks';
import { useHeaderFooter } from 'src/hooks/useHeaderFooter';
import { useLanguageSwitcher } from 'src/hooks/useLanguageSwitcher/useLanguageSwitcher';
import type { HeaderProps } from 'src/types';

const Header = ({
  loading,
  error,
  emailAddress,
  firstName,
  width,
  activeAuthedUserTab,
}: HeaderProps) => {
  const { authenticationStatus } = useHeaderFooter({
    error,
    loading,
  });
  const headerLink = useHeaderFooterLinkProvider();
  const languageSwitcher = useLanguageSwitcher();

  return (
    <ApacCandidateHeaderFooterLinkProvider value={headerLink}>
      <ApacCandidateHeader
        activeAuthedUserTab={activeAuthedUserTab}
        authenticationStatus={authenticationStatus}
        divider
        languageSwitcher={languageSwitcher}
        userProfile={{
          firstName: firstName || '',
          lastName: '',
          email: emailAddress || '',
        }}
        widthMode={width}
      />
    </ApacCandidateHeaderFooterLinkProvider>
  );
};

export default Header;
